import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import { queryKeys } from '../../../api/queryKeys';
import type { ReceiptListResponse } from '../../../types/api';

export interface ReceiptListFilters {
  page: number;
  limit?: number;
  status?: string;
  date_from?: string;
  date_to?: string;
  registration?: string;
  driver_uuid?: string;
  /** Legacy COVD parity — true filters to Sent tab, false to Unsent. */
  is_sent?: boolean;
  /** Free-text search over customer name + registration. */
  search?: string;
  /** Digital Waste Tracking filter (admins; ignored by the server otherwise). */
  dwt?: string;
}

export function useReceiptList(filters: ReceiptListFilters) {
  return useQuery<ReceiptListResponse>({
    queryKey: queryKeys.receipts.list(filters as unknown as Record<string, unknown>),
    queryFn: async () => {
      const params = new URLSearchParams();
      params.set('page', String(filters.page));
      if (filters.limit) params.set('limit', String(filters.limit));
      if (filters.status) params.set('status', filters.status);
      if (filters.date_from) params.set('date_from', filters.date_from);
      if (filters.date_to) params.set('date_to', filters.date_to);
      if (filters.registration) params.set('registration', filters.registration);
      if (filters.driver_uuid) params.set('driver_uuid', filters.driver_uuid);
      if (filters.is_sent !== undefined) params.set('is_sent', String(filters.is_sent));
      if (filters.search) params.set('search', filters.search);
      if (filters.dwt) params.set('dwt', filters.dwt);

      const res = await apiClient.get<ReceiptListResponse>(
        `${endpoints.receipts.list}?${params.toString()}`,
      );
      return res.data;
    },
    staleTime: 30_000,
  });
}
